module.exports = __webpack_public_path__ + "media/images/solo-200-new@2x-0b6ffb88918eb635acff7eb267e9ceff.webp";